import { render, staticRenderFns } from "./InputsRectangleTypeMask.vue?vue&type=template&id=51ce07c4"
import script from "./InputsRectangleTypeMask.vue?vue&type=script&lang=js"
export * from "./InputsRectangleTypeMask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports